<template>
    <div class="page" id="page_contact">

        <form action="#" method="POST" role="form" class="content-container" @submit="onSubmit">
            <h2><b>Enquiry</b></h2>
            <p><i class="warning">* Fields required</i></p>

            <fieldset>
                    <div class="form-group">
                        <input type="text" id="name" name="name" :value="formData.name" placeholder="Name *" class="form-control" @change="inputChange" />
                    </div>
                    <div class="form-group">
                        <input type="text" id="company" name="company" :value="formData.company" placeholder="Company *" class="form-control" @change="inputChange" />
                    </div>
                    <div class="form-group">
                        <input type="tel" id="phone" name="phone" :value="formData.phone" placeholder="Phone *" class="form-control" @change="inputChange" />
                    </div>
                    <div class="form-group">
                        <input type="email" id="email" name="email" :value="formData.email" placeholder="Email *" class="form-control" @change="inputChange"/>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="form-group">
                        <input type="text" id="address" name="address" :value="formData.address" placeholder="Address *" class="form-control" @change="inputChange"/>
                    </div>
                    <div class="form-group">
                        <input type="text" id="city" name="city" :value="formData.city" placeholder="City / State *" class="form-control" @change="inputChange"/>
                    </div>
                    <div class="form-group">
                        <input type="text" id="postal" name="postal" :value="formData.postal" placeholder="Postal Code *" class="form-control" @change="inputChange"/>
                    </div>
                    <div class="form-group">
                        <select type="text" id="country" name="country" :value="formData.country" class="form-control" @change="inputChange">
                            <option value="">-- Country * --</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="American Samoa">American Samoa</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Anguilla">Anguilla</option>
                                <option value="Antarctica">Antarctica</option>
                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Aruba">Aruba</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bermuda">Bermuda</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Bouvet Island">Bouvet Island</option>
                                <option value="Brazil">Brazil</option>
                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Cape Verde">Cape Verde</option>
                                <option value="Cayman Islands">Cayman Islands</option>
                                <option value="Central African Republic">Central African Republic</option>
                                <option value="Chad">Chad</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Christmas Island">Christmas Island</option>
                                <option value="Cocos (Keeling Islands)">Cocos (Keeling Islands)</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo">Congo</option>
                                <option value="Cook Islands">Cook Islands</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Cote D'Ivoire (Ivory Coast)">Cote D'Ivoire (Ivory Coast)</option>
                                <option value="Croatia (Hrvatska">Croatia (Hrvatska</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Dominica">Dominica</option>
                                <option value="East Timor">East Timor</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                <option value="Faroe Islands">Faroe Islands</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France, Metropolitan">France, Metropolitan</option>
                                <option value="France">France</option>
                                <option value="French Guiana">French Guiana</option>
                                <option value="French Polynesia">French Polynesia</option>
                                <option value="French Southern Territories">French Southern Territories</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia">Gambia</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Gibraltar">Gibraltar</option>
                                <option value="Greece">Greece</option>
                                <option value="Greenland">Greenland</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guadeloupe">Guadeloupe</option>
                                <option value="Guam">Guam</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guinea-Bissau">Guinea-Bissau</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Heard and McDonald Islands">Heard and McDonald Islands</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hong Kong">Hong Kong</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Iran">Iran</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Korea (North)">Korea (North)</option>
                                <option value="Korea (South)">Korea (South)</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Laos">Laos</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Libya">Libya</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Macau">Macau</option>
                                <option value="Macedonia">Macedonia</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">Marshall Islands</option>
                                <option value="Martinique">Martinique</option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mayotte">Mayotte</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Micronesia">Micronesia</option>
                                <option value="Moldova">Moldova</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montserrat">Montserrat</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="New Caledonia">New Caledonia</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="Niger">Niger</option>
                                <option value="Niue">Niue</option>
                                <option value="Norfolk Island">Norfolk Island</option>
                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau">Palau</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Pitcairn">Pitcairn</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Puerto Rico">Puerto Rico</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Reunion">Reunion</option>
                                <option value="Romania">Romania</option>
                                <option value="Russian Federation">Russian Federation</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="S. Georgia and S. Sandwich Isls.">S. Georgia and S. Sandwich Isls.</option>
                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                <option value="Saint Lucia">Saint Lucia</option>
                                <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                <option value="Samoa">Samoa</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">Sierra Leone</option>
                                <option value="Slovak Republic">Slovak Republic</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">Solomon Islands</option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="St. Helena">St. Helena</option>
                                <option value="St. Pierre and Miquelon">St. Pierre and Miquelon</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Svalbard and Jan Mayen Islands">Svalbard and Jan Mayen Islands</option>
                                <option value="Swaziland">Swaziland</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syria">Syria</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Togo">Togo</option>
                                <option value="Tokelau">Tokelau</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">Turkmenistan</option>
                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="US Minor Outlying Islands">US Minor Outlying Islands</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="United States">United States</option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Vatican City State">Vatican City State</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Viet Nam">Viet Nam</option>
                                <option value="Virgin Islands (British)">Virgin Islands (British)</option>
                                <option value="Virgin Islands (US)">Virgin Islands (US)</option>
                                <option value="Wallis and Futuna Islands">Wallis and Futuna Islands</option>
                                <option value="Western Sahara">Western Sahara</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Yugoslavia">Yugoslavia</option>
                                <option value="Zaire">Zaire</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                        </select>
                    </div>
                </fieldset>
                <fieldset class="fullWidth">
                    <div class="form-group">
                        <textarea type="text" id="messages" name="message" :value="formData.messages" placeholder="Messages *" class="form-control" rows="6" @change="inputChange"></textarea>
                    </div>
                </fieldset>
                
                <input type="submit" id="submit" value="Submit" class="btn" />

        </form>
    </div>
</template>

<script>
import isEmail from 'validator/lib/isEmail';
import isInt from 'validator/lib/isInt';
//import GoogleMap from "./GoogleMap";

export default {
    name: 'Contact',
    data() {
        return {
            formData: {
                name: '',
                company: '',
                phone: '',
                email: '',
                address: '',
                city: '',
                postal: '',
                country: '',
                message: ''
            }
        }
    },
    components: {
       //GoogleMap
    },
    methods: {
        inputChange(e) {
            //window.console.log(e.target.value);
            this.formData[e.target.name] = e.target.value;
        },
        onSubmit(e) {
            
            let error = '';
            if (this.formData.name.trim() == '') {
                error += 'Please enter name. <br>';
            }
            if (!this.formData.company.trim()) {
                error += 'Please enter your company name. <br>';
            }
            if (!this.formData.phone.trim()) {
                error += 'Please enter your phone number. <br>';
            }
            else if (!isInt(this.formData.phone.trim())) {
                error += 'Please enter a numeric phone number. <br>';
            }
            if (!this.formData.email.trim()) {
                error += 'Please enter your email. <br>';
            }
            else if (!isEmail(this.formData.email.trim())) {
                error += 'Please enter a correct email format. <br>';
            }
            if (!this.formData.address.trim()) {
                error += 'Please enter your address. <br>';
            }
            if (!this.formData.city.trim()) {
                error += 'Please enter your city. <br>';
            }
            if (!this.formData.postal.trim()) {
                error += 'Please enter your postal. <br>';
            }
            if (!this.formData.country.trim()) {
                error += 'Please select your country. <br>';
            }
            if (!this.formData.message.trim()) {
                error += 'Please enter your message. <br>';
            }
            
            if (error) {
                this.$modal.show('dialog', {
                    title: 'Error',
                    text: error,
                });
                
            }
            else {
                this.$modal.show('dialog', {
                    title: 'Successful',
                    text: 'Submission is successful.',
                });
            }
            e.preventDefault();
        }
    },
    mounted () {
        
    }
}
</script>

<style lang="less" scoped>
#page_contact {
    //background: #073fa5;
    background: @red;

    .content-container {
        padding-top: 0;
        //padding-bottom: 0;
    }
    h2 {
        border-radius: 0 0 90px 90px;
        border: 8px solid @lightColor;
        border-top: none;
        background: #ffe730;
        color: #490c09;
        font-size: 2em;
        line-height: 1em;
        height: 100px;
        margin: 0 auto 20px;
        padding: 23px 00px 00px;
        position: relative;
        text-transform: uppercase;
        text-align: center;
        width: 180px;
    }
    .warning {
        color: @lightColor;
        display: block;
        font-size: 0.7em;
        margin: 0 0 0px;
    }
    fieldset {
        border: none;
        border-bottom: 1px solid darken(@grey,10%);
        margin: 0 0 20px;
        padding: 0 0 0;
    }
    .form-group {
        margin-bottom: 15px;
    }
    .form-control {
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        width: 100%;
    }
    .btn {
        background-color: darken(@grey,10%);
        border-color: @grey;
        border-radius: 4px;
        color: @lightColor;
        cursor: pointer;
        font-size: 14px;
        padding: 12px 12px;
        text-transform: uppercase;
        width: 100%;
    }
    .error {
        color: @red;
    }
}

@media only screen and (min-width : 768px) {
    #page_contact {
        position: relative;

        form {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: 0 -2.5%;

            h2 {
                margin: 0 auto 20px;
            }
            p {
                margin: 0 2.5% 20px;
                width: 100%;
            }
            fieldset {
                margin: 0 2.5% 20px;
                width: 45%;

                &.fullWidth {

                    width: 100%;
                }
            }
            select {
                height: 34px;
            }
            .btn {
                margin: 0 auto;
                width: 50%;
            }

        }
        
    }
}
</style>